import {saveData, getData, findByOfflineID, findByUser, clearData, customFind} from "../db/db_helper"

//load from DB
export const getOnlineRegisterEntries = async () =>{
    return await getData("register_entries") || []
}

export const getOffllineRegisterEntries = async () =>{
    return await getData("sync_register_entries") || []
}

export const getAllRegisterEntries = async () =>{
    const online = await getOnlineRegisterEntries()
    const offline = await getOffllineRegisterEntries()
    const all = [...online, ...offline]
    return all.sort((a, b) => a.start_time - b.start_time);
}

export const getRegisterEntriesByOfflineId = async(id)=>{
    const online = await findByOfflineID("register_entries", id)
    const offline = await findByOfflineID("sync_register_entries", id)
    return online || offline || null
}

export const clearSyncRegisterEntries = () =>{
    clearData("sync_register_entries")
}

const isToday = (dateStr) => {
    if (!dateStr) return false
    const d = new Date(dateStr)
    const now = new Date()
    return d.getFullYear() === now.getFullYear() &&
           d.getMonth() === now.getMonth() &&
           d.getDate() === now.getDate()
}

export const findByUserCode = async (code) => {
    const online = await findByUser("register_entries", code)
    const offline = await findByUser("sync_register_entries", code)
    const entry = online || offline || null
    return entry && isToday(entry.startTime) ? entry : null
}

export const findByUserCodeNoAccounted = async (user) => {
    const online = await customFind("register_entries", codeAndNoAccountedFilter(user.numberCode))
    const offline = await customFind("sync_register_entries", codeAndNoAccountedFilter(user.numberCode))
    const entry = online || offline || null
    return entry && isToday(entry.startTime) ? entry : null
}

const codeAndNoAccountedFilter = (code) => (i) => {
    return i?.user?.numberCode === code && i?.startAmount === null
} 

export const saveRegisterEntries = async (obj) =>{
    saveData("register_entries", obj)
}

export const saveOfflineRegisterEntries = async (obj) =>{
    saveData("sync_register_entries", obj)
}

export const getRegisterIndex = (id, orderArray)=>{
    return orderArray.findIndex(o => o.offlineId === id);
}

export async function updateEntryBalance(balance, offlineId, isAccounting = false, serverTarget= null){
    const target = await getRegisterEntriesByOfflineId(offlineId) || serverTarget || null
    const online = await getOnlineRegisterEntries()
    const offline = await getOffllineRegisterEntries()

    if(isAccounting){
        target.startAmount = balance
    } else {
        target.finalAmount = balance
    }

    let index = -1
    index = await getRegisterIndex(offlineId, online)
    if(index !== -1){
        online.splice(index,1)
        await saveData("register_entries", online)
        offline.push(target)
        await saveData("sync_register_entries", offline)
        return
    }

    index = await getRegisterIndex(offlineId, offline)
    if(index !== -1){
        offline[index] = target
        await saveData("sync_register_entries", offline)
        return
    }

    if(serverTarget){
        offline.push(serverTarget)
        await saveData("sync_register_entries", offline)
        return
    }
}
